"use client";

import React from "react";
import { Modal } from "@aph/ui-lib-humanx";
import styles from "@/components/ValentinePopup/popup.module.scss";
import CardsComponent from "@/components/ValentinePopup/components/CardsComponent";
import InitialCard from "@/components/ValentinePopup/components/InitialCard";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import ValentineModalSelector from "@/components/ValentinePopup/redux/selectors/valentineModalSelector";
import { DeviceInfo } from "@/interface/deviceInfo";
import { setIsValentineModalOpen } from "./redux/slice";

interface ValentinePopupProps {
  deviceInfo: DeviceInfo;
}

const ValentinePopup: React.FC<ValentinePopupProps> = ({ deviceInfo }) => {
  const dispatch = useAppDispatch();
  const handleCardModalOpen = useAppSelector(ValentineModalSelector);
  const [initialCard, setInitialCard] = React.useState<boolean>(true);

  const [formData, setFormData] = React.useState({ title: "", description: "" });
  const cardRef = React.useRef<HTMLDivElement>(null);

  const setHandleCardModalOpen = (isOpen: boolean) => {
    dispatch(setIsValentineModalOpen(isOpen));
  };

  return (
    <>
      <Modal
        open={handleCardModalOpen}
        size="md"
        mobileBottomAlign
        handleOpen={setHandleCardModalOpen}
        backdropClose
        isHXModal
        modalContentClass={styles.contentClass}
        titleClass={styles.titleClass}
        modalboxClass={`${styles.modal} `}
        modalActionClass={styles.sideFlexFilter}
      >
        <div className={styles.modalWrapper}>
          {initialCard ? (
            <InitialCard setInitialCard={setInitialCard} deviceInfo={deviceInfo} />
          ) : (
            <CardsComponent setFormData={setFormData} formData={formData} cardRef={cardRef} deviceInfo={deviceInfo} />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ValentinePopup;
